<ion-list>
  <ion-item
    button
    lines="none"
    [routerLink]="dashboardLink"
    (click)="onDashboardClick($event)"
  >
    <ion-icon slot="start" name="grid-outline" class="mx-1"></ion-icon>
    <ion-label class="ms-4">Home</ion-label>
  </ion-item>
  
  <ion-item 
    button
    lines="none"
    (click)="onItemClick()"
  >
    <ion-icon slot="start" name="person-circle-outline"></ion-icon>
    <ion-label>
      <h2> {{userProfile?.firstName + userProfile?.lastName}}</h2>
      <p *ngIf="userProfile?.emailId" [innerText]="userProfile?.emailId"></p>
      <ng-template #emailId
        ><h2 [innerText]="userProfile?.emailId"></h2
      ></ng-template>
    </ion-label>
  </ion-item>

  <ion-item button lines="none" (click)="onSwitchClick($event)">
    <ion-icon slot="start" name="sync-outline"></ion-icon>
    <ion-label> Switch Account </ion-label>
  </ion-item>

  <ion-item button lines="none" (click)="onLogoutClick($event)">
    <ion-icon slot="start" name="log-out-outline"></ion-icon>
    <ion-label>Logout</ion-label>
  </ion-item>
</ion-list>
